import React from "react";
import { Menu, MenuItem } from "@mui/material";
import AssignmentIcon from "@mui/icons-material/Assignment";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useUser } from "../../context/AuthContext";

const MenuActions = ({
  handleView,
  handleEdit,
  handleDelete,
  anchorEl,
  handleMenuClose,
}) => {
  // const { user } = useUser();
  const isOpen = Boolean(anchorEl);
  // const isCompanyAdmin = user?.companyAdmin;

  const menuItemStyle = { fontSize: "14px" };
  const iconStyle = { marginRight: "8px", fontSize: "large" };

  return (
    <Menu
      anchorEl={anchorEl}
      open={isOpen}
      onClose={handleMenuClose}
      PaperProps={{
        sx: {
          width: 120,
          border: "1px solid #ddd",
          marginLeft: "-47px",
        },
      }}
    >
      <MenuItem onClick={handleView} sx={menuItemStyle}>
        <AssignmentIcon sx={iconStyle} /> View Logs
      </MenuItem>

      {/* {!isCompanyAdmin && ( */}
        <>
          <MenuItem onClick={handleEdit} sx={menuItemStyle}>
            <EditIcon sx={iconStyle} /> Edit
          </MenuItem>
          <MenuItem onClick={handleDelete} sx={menuItemStyle}>
            <DeleteIcon sx={iconStyle} /> Delete
          </MenuItem>
        </>
      {/* )} */}
    </Menu>
  );
};

export default MenuActions;
